import { render, staticRenderFns } from "./ExternalApiSyncComponent.vue?vue&type=template&id=51381d20&scoped=true&"
import script from "./ExternalApiSyncComponent.vue?vue&type=script&lang=ts&"
export * from "./ExternalApiSyncComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalApiSyncComponent.vue?vue&type=style&index=0&id=51381d20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51381d20",
  null
  
)

export default component.exports